module.exports = __webpack_public_path__ + "img/header-analyse-waermeplanung.00df623b.png";